export default class NotificationHeaderItem extends HTMLDivElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();
    }

    initEvents() {
        this.addEventListener('click', e => {
            let {target} = e;
            let delegationSelector = 'a';
            let match = target.matches(delegationSelector);

            // Si l'élement cliqué n'est un lien
            if (!match && !(target.parentNode && target.parentNode.matches(delegationSelector))) {
                return false;
            }

            if(!match)
            {
                target = target.parentNode;
            }

            e.preventDefault();
            let urlToRedirect = target.getAttribute('href');
            HegydCore.sendRequest(
                target.getAttribute('data-href-read'),
                'PUT',
                {},
                data => {
                    window.location.href = urlToRedirect;
                }
            );
        });
    }
}